import { render, staticRenderFns } from "./GrmDraggableResizable.vue?vue&type=template&id=bc82ff1a&scoped=true&"
import script from "./GrmDraggableResizable.vue?vue&type=script&lang=js&"
export * from "./GrmDraggableResizable.vue?vue&type=script&lang=js&"
import style0 from "./GrmDraggableResizable.vue?vue&type=style&index=0&id=bc82ff1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc82ff1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc82ff1a')) {
      api.createRecord('bc82ff1a', component.options)
    } else {
      api.reload('bc82ff1a', component.options)
    }
    module.hot.accept("./GrmDraggableResizable.vue?vue&type=template&id=bc82ff1a&scoped=true&", function () {
      api.rerender('bc82ff1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/draggableResizable/GrmDraggableResizable.vue"
export default component.exports